import { Component, OnInit, Input } from '@angular/core';
import { NewRelicService } from '../../../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { ComposableService } from '../services/composable.service';

import { Router } from '@angular/router';
@Component({
  selector: 'error-session',
  templateUrl: './error-session.component.html',
  styles: []
})
export class ErrorSessionComponent implements OnInit {
  @Input() role: string;
  constructor(
    private newRelicService: NewRelicService,
    private composableService: ComposableService,
    public router: Router
  ){}

  ngOnInit() {
    this.newRelicService.addPageAction('error-session', { status: 'error' });
    // reset app state

  }
  goToProposedInsuredAuthPage() {
    //history.pushState(null, null, 'express/find-application');  
    this.composableService.resetApplication();
    this.router.navigateByUrl('express/find-application');
  }
  goToProducerAuthPage() {
    //history.pushState(null, null, 'express/welcome');  
    this.composableService.resetApplication();
    this.router.navigateByUrl('express/welcome');    
  }

}
